import React from 'react';
import { Avatar, Box, Typography } from '@mui/material';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';

const avatarStyles = {
  backgroundColor: 'error.light',
  color: 'error.dark',
  fontSize: 16,
  height: 24,
  mr: 1.5,
  width: 24,
};

const boxStyles = {
  alignItems: 'center',
  backgroundColor: 'surface.white',
  boxShadow: 1,
  display: 'flex',
  flexDirection: 'row',
  height: 74,
  justifyContent: 'flex-start',
  mt: 1,
  mx: 'auto',
  pl: 2,
};

const ErrorHeader = () => (
  <Box sx={boxStyles}>
    <Avatar sx={avatarStyles}>
      <PriorityHighIcon />
    </Avatar>
    <Typography color="inherit" sx={{ fontWeight: 700 }} variant="h7">
      Error submitting some of your drivers.
    </Typography>
  </Box>
);

export default ErrorHeader;
